// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

const Chevron = ({
  className, color, direction, height, width,
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 82.98 71.97"
    fill={color}
    width={width}
    height={height || width}>
    <g>
      <g>
        <polygon points="0 0.02 41.45 40.98 82.98 0 82.98 30.97 41.54 71.97 0 30.97 0 0.02" />
      </g>
    </g>
  </svg>
)

Chevron.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  direction: PropTypes.oneOf([
    'north', 'east', 'south', 'west', 'northeast',
  ]).isRequired,
}

Chevron.defaultProps = {
  color: '#000',
  direction: 'north',
  width: '50px',
}

export default styled(Chevron)`
  display: inline-block;
  margin-top: -3px;

  ${(props) => props.direction === 'north' && `
    transform: rotate(-180deg);
  `}

  ${(props) => props.direction === 'east' && `
    transform: rotate(-90deg);
  `}

  ${(props) => props.direction === 'west' && `
    transform: rotate(90deg);
  `}

  ${(props) => props.direction === 'northeast' && `
    transform: rotate(-135deg);
  `}

`
